import React, { useState, useEffect, useContext } from "react";
import qs from 'query-string'

import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import usePlans from '../../hooks/usePlans';
import { i18n } from "../../translate/i18n";
import { InputLabel, MenuItem, Select, FormControlLabel, Checkbox, FormControl } from "@material-ui/core";
import LegalRequirementModal from "../../components/LegalRequirementModal";
import { Helmet } from "react-helmet";

import { openApi } from "../../services/api";
import toastError from "../../errors/toastError";
import useSettings from "../../hooks/useSettings";
import ColorModeContext from "../../layout/themeContext";
import { getBackendUrl } from "../../config";
import clsx from "clsx";
import PublicLanguageSelector from "../../components/PublicLanguageSelector";

const useStyles = makeStyles(theme => {
    const { mode } = theme;
    return ({
        root: {
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "40px 20px", // Añadido padding lateral
            boxSizing: "border-box",
            overflowX: "hidden",
            overflowY: "auto",
            position: "relative",
            backgroundColor: theme.palette.background ? theme.palette.background.default : (theme.palette.type === "light" ? "#f5f5f5" : "#303030"),
            backgroundImage: "none",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",

            [theme.breakpoints.down("sm")]: {
                justifyContent: "flex-start", // En móviles empezamos desde arriba
            },
        },
        containerSignup: {
            padding: "0",
            width: "100%",
            zIndex: 10,
            position: "relative",
            maxWidth: "850px",
            margin: "0 auto",

            [theme.breakpoints.down("sm")]: {
                width: "100%",
                maxWidth: "100%",
            },
        },
        paper: {
            backgroundColor: theme.palette.type === "light" ? "rgba(255, 255, 255, 0.95)" : "rgba(40, 40, 40, 0.95)",
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)",
            boxShadow: theme.palette.type === "light" ? `
        0 20px 40px rgba(0, 0, 0, 0.1),
        0 1px 0 rgba(255, 255, 255, 0.2) inset,
        0 0 0 1px rgba(255, 255, 255, 0.1)
      ` : `
        0 20px 40px rgba(0, 0, 0, 0.5),
        0 1px 0 rgba(0, 0, 0, 0.2) inset,
        0 0 0 1px rgba(0, 0, 0, 0.1)
      `,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "20px 25px", // Reducido de 30px
            borderRadius: "20px",
            maxWidth: "850px",
            width: "100%",
            margin: "0 auto",
            border: theme.palette.type === "light" ? "1px solid rgba(255, 255, 255, 0.2)" : "1px solid rgba(0, 0, 0, 0.2)",
            animation: "$slideInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
            position: "relative",
            boxSizing: "border-box",

            [theme.breakpoints.down("sm")]: {
                animation: "$slideInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
                borderRadius: "16px",
                padding: "15px 15px", // Reducido de 25px 20px
                boxSizing: "border-box",
                width: "100%",
            },

            [theme.breakpoints.down("xs")]: {
                padding: "10px 10px", // Reducido de 20px 15px
                borderRadius: "14px",
                boxShadow: `0 15px 30px rgba(0, 0, 0, 0.12)`,
                boxSizing: "border-box",
                width: "100%",
            },
        },
        avatar: {
            margin: theme.spacing(0.5), // Reducido
            backgroundColor: theme.palette.primary.main,
            display: "none", // Ocultamos el avatar para ganar espacio superior
        },
        form: {
            width: "100%",
            marginTop: theme.spacing(1), // Reducido de 3
        },
        submit: {
            margin: theme.spacing(1.5, 0, 1), // Reducido de (3, 0, 2)
            background: mode === "light"
                ? `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`
                : `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
            color: "white",
            borderRadius: "12px",
            padding: "12px 0",
            fontSize: "16px",
            fontWeight: 600,
            textTransform: "none",
            boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
            border: "none",
            transition: "all 0.3s ease",
            "&:hover": {
                background: mode === "light"
                    ? `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.primary.dark})`
                    : `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.primary.dark})`,
                transform: "translateY(-2px)",
                boxShadow: `0 6px 20px ${theme.palette.primary.main}66`,
            },
            "&:active": {
                transform: "translateY(0)",
            },
        },
        "@keyframes slideInUp": {
            from: {
                opacity: 0,
                transform: "translateY(30px)",
            },
            to: {
                opacity: 1,
                transform: "translateY(0)",
            },
        },
        menuPaper: {
            width: "850px !important",
            minWidth: "850px !important",
            maxWidth: "95vw !important",
            [theme.breakpoints.down("sm")]: {
                width: "95vw !important",
                minWidth: "auto !important",
            },
        },
    })
});

const UserSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, i18n.t("signup.validations.tooShort"))
        .max(50, i18n.t("signup.validations.tooLong"))
        .required(i18n.t("signup.validations.required")),
    companyName: Yup.string()
        .min(2, i18n.t("signup.validations.tooShort"))
        .max(50, i18n.t("signup.validations.tooLong"))
        .required(i18n.t("signup.validations.required")),
    // document: Yup.string()
    //     .test('document-format', 'CPF deve ter 11 dígitos ou CNPJ deve ter 14 dígitos', function (value) {
    //         if (!value) return false;
    //         const numbers = value.replace(/\D/g, '');
    //         return numbers.length === 11 || numbers.length === 14;
    //     })
    //     .required("CPF ou CNPJ é obrigatório"),
    password: Yup.string().min(5, i18n.t("signup.validations.tooShort")).max(50, i18n.t("signup.validations.tooLong")),
    email: Yup.string().email(i18n.t("signup.validations.invalidEmail")).required(i18n.t("signup.validations.required")),
    phone: Yup.string().required(i18n.t("signup.validations.required")),
    timezone: Yup.string().required(i18n.t("signup.validations.required")),
});

const getTimeZones = () => {
    try {
        const timeZones = Intl.supportedValuesOf('timeZone');
        const now = new Date();

        return timeZones.map(tz => {
            try {
                const formatter = new Intl.DateTimeFormat('en-US', {
                    timeZone: tz,
                    timeZoneName: 'shortOffset',
                });
                const parts = formatter.formatToParts(now);
                const offset = parts.find(part => part.type === 'timeZoneName').value;

                return {
                    name: tz,
                    label: `(${offset}) ${tz}`,
                };
            } catch (e) {
                return { name: tz, label: tz };
            }
        }).sort((a, b) => {
            return a.label.localeCompare(b.label, undefined, { numeric: true });
        });
    } catch (e) {
        return [
            { name: "America/Lima", label: "(GMT-05:00) America/Lima" },
            { name: "America/Sao_Paulo", label: "(GMT-03:00) America/Sao_Paulo" },
            { name: "America/Mexico_City", label: "(GMT-06:00) America/Mexico_City" },
            { name: "America/Bogota", label: "(GMT-05:00) America/Bogota" },
            { name: "America/Santiago", label: "(GMT-04:00) America/Santiago" },
            { name: "America/Argentina/Buenos_Aires", label: "(GMT-03:00) America/Argentina/Buenos_Aires" },
            { name: "America/Caracas", label: "(GMT-04:00) America/Caracas" },
            { name: "America/Guayaquil", label: "(GMT-05:00) America/Guayaquil" },
            { name: "America/La_Paz", label: "(GMT-04:00) America/La_Paz" },
            { name: "UTC", label: "(GMT) UTC" }
        ];
    }
};

const tzList = getTimeZones();

const SignUp = () => {
    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory();
    const { colorMode } = useContext(ColorModeContext);
    const { appLogoFavicon, appName, mode } = colorMode;
    const { getPlanList } = usePlans()
    const [plans, setPlans] = useState([])
    const [loading, setLoading] = useState(false);
    const [validatingCnpj, setValidatingCnpj] = useState(false);
    const [lastValidatedDocument, setLastValidatedDocument] = useState("");

    const { getPublicSetting } = useSettings();
    const [success, setSuccess] = useState(false);
    const [registeredEmail, setRegisteredEmail] = useState("");

    const [backgroundLight, setBackgroundLight] = useState("");
    const [backgroundDark, setBackgroundDark] = useState("");

    let companyId = null
    const params = qs.parse(window.location.search)
    if (params.companyId !== undefined) {
        companyId = params.companyId
    }
    const isReseller = !!params.ref;

    const initialState = { name: "", email: "", password: "", phone: "", companyId, companyName: "", document: "", planId: "", timezone: "America/Lima" };

    const [user, setUser] = useState(initialState);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [showTerms, setShowTerms] = useState(false);
    const [showPrivacy, setShowPrivacy] = useState(false);

    useEffect(() => {
        getPublicSetting("userCreation")
            .then((data) => {
                if (data === "disabled") {
                    // toast.error(i18n.t("signup.toasts.disabled"));
                    // history.push("/login");
                }
            })
            .catch((error) => {
                console.log("Error reading setting", error);
            });

        getPublicSetting("appLogoBackgroundLight", companyId)
            .then((bgLight) => {
                if (bgLight) {
                    const backendUrl = getBackendUrl();
                    const fullUrl = backendUrl + "/public/" + bgLight;
                    console.log("Background light URL:", fullUrl);
                    setBackgroundLight(fullUrl);
                } else {
                    setBackgroundLight("");
                }
            })
            .catch((err) => {
                console.error(i18n.t("signup.errors.bgLight"), err);
                setBackgroundLight("");
            });

        getPublicSetting("appLogoBackgroundDark", companyId)
            .then((bgDark) => {
                if (bgDark) {
                    const backendUrl = getBackendUrl();
                    const fullUrl = backendUrl + "/public/" + bgDark;
                    console.log("Background dark URL:", fullUrl);
                    setBackgroundDark(fullUrl);
                } else {
                    setBackgroundDark("");
                }
            })
            .catch((err) => {
                console.error(i18n.t("signup.errors.bgDark"), err);
                setBackgroundDark("");
            });
    }, [history, companyId]);

    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            const planList = await getPlanList();

            setPlans(planList);
            
            const publicPlans = planList.filter(p => p.id !== 1 && p.id !== "1" && p.isPublic);
            if (publicPlans.length > 0) {
                const getPriority = (name) => {
                    const upperName = (name || "").toUpperCase();
                    if (upperName.includes('FREEMIUM')) return 1;
                    if (upperName.includes('DEMO')) return 2;
                    if (upperName.startsWith('BA')) return 3;
                    if (upperName.startsWith('AD')) return 4;
                    if (upperName.startsWith('PR')) return 5;
                    if (upperName.includes('PLANO 1')) return 7;
                    return 6;
                };
                
                const sortedPlans = [...publicPlans].sort((a, b) => {
                    const nameA = (a.name || "").toUpperCase();
                    const nameB = (b.name || "").toUpperCase();
                    const priorityA = getPriority(nameA);
                    const priorityB = getPriority(nameB);
                    if (priorityA !== priorityB) {
                        return priorityA - priorityB;
                    }
                    return nameA.localeCompare(nameB);
                });
                
                const defaultPlan = sortedPlans.find(p => (p.name || "").toUpperCase().includes("FREEMIUM")) || 
                                    sortedPlans.find(p => (p.name || "").toUpperCase().includes("DEMO")) || 
                                    sortedPlans[0];
                setUser(prev => ({ ...prev, planId: defaultPlan.id }));
            }
            
            setLoading(false);
        }
        fetchData();
    }, []);

    const validateCpf = (cpf) => {
        const cleanCpf = cpf.replace(/\D/g, '');

        if (cleanCpf.length !== 11) return false;

        if (/^(\d)\1{10}$/.test(cleanCpf)) return false;

        let sum = 0;
        for (let i = 0; i < 9; i++) {
            sum += parseInt(cleanCpf.charAt(i)) * (10 - i);
        }
        let remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cleanCpf.charAt(9))) return false;

        sum = 0;
        for (let i = 0; i < 10; i++) {
            sum += parseInt(cleanCpf.charAt(i)) * (11 - i);
        }
        remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cleanCpf.charAt(10))) return false;

        return true;
    };

    const formatCpf = (value) => {
        const numbers = value.replace(/\D/g, '');
        const limitedNumbers = numbers.slice(0, 11);

        if (limitedNumbers.length <= 3) return limitedNumbers;
        if (limitedNumbers.length <= 6) return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3)}`;
        if (limitedNumbers.length <= 9) return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3, 6)}.${limitedNumbers.slice(6)}`;
        return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3, 6)}.${limitedNumbers.slice(6, 9)}-${limitedNumbers.slice(9)}`;
    };

    const formatCnpj = (value) => {
        const numbers = value.replace(/\D/g, '');
        const limitedNumbers = numbers.slice(0, 14);

        if (limitedNumbers.length <= 2) return limitedNumbers;
        if (limitedNumbers.length <= 5) return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2)}`;
        if (limitedNumbers.length <= 8) return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2, 5)}.${limitedNumbers.slice(5)}`;
        if (limitedNumbers.length <= 12) return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2, 5)}.${limitedNumbers.slice(5, 8)}/${limitedNumbers.slice(8)}`;
        return `${limitedNumbers.slice(0, 2)}.${limitedNumbers.slice(2, 5)}.${limitedNumbers.slice(5, 8)}/${limitedNumbers.slice(8, 12)}-${limitedNumbers.slice(12)}`;
    };

    const detectDocumentType = (value) => {
        const numbers = value.replace(/\D/g, '');
        if (numbers.length <= 11) return 'cpf';
        return 'cnpj';
    };



    const validateDocument = async (document, setFieldValue) => {
        const cleanDocument = document.replace(/\D/g, '');

        if (lastValidatedDocument === cleanDocument) {
            return true;
        }

        const documentType = detectDocumentType(document);

        if (documentType === 'cpf') {
            if (validateCpf(document)) {
                setLastValidatedDocument(cleanDocument);
                toast.success(i18n.t("signup.toasts.cpfValid"));
                return true;
            } else {
                setLastValidatedDocument(cleanDocument);
                toast.error(i18n.t("signup.toasts.invalidCpf"));
                return false;
            }
        } else {
            if (cleanDocument.length !== 14) return false;

            setValidatingCnpj(true);
            try {
                const response = await openApi.post("/auth/validate-cnpj", { cnpj: cleanDocument });
                const data = response.data;
                setValidatingCnpj(false);

                if (data.valid && data.data.nome) {
                    if (data.data.tipo === 'cnpj') {
                        setFieldValue('companyName', data.data.nome);
                        toast.success(i18n.t("signup.toasts.cnpjValid"));
                    } else {
                        toast.success(i18n.t("signup.toasts.cpfValid"));
                    }
                    setLastValidatedDocument(cleanDocument);
                    return true;
                } else {
                    setLastValidatedDocument(cleanDocument);
                    toast.error(i18n.t("signup.toasts.invalidDocument"));
                    return false;
                }
            } catch (error) {
                setValidatingCnpj(false);
                console.error("Erro ao validar documento:", error);
                toast.error(i18n.t("signup.toasts.validationError"));
                setLastValidatedDocument(cleanDocument);
                return false;
            }
        }
    };

    const handleSignUp = async values => {
        try {
            const parsed = qs.parse(window.location.search);
            if (parsed.ref) {
                values.resellerId = parsed.ref;
            }
            const response = await openApi.post("/auth/signup", values);
            
            if (response.data?.paymentLink) {
                window.location.href = response.data.paymentLink;
                return;
            }
            
            toast.success(i18n.t("signup.toasts.success"));
            setRegisteredEmail(values.email);
            setSuccess(true);
        } catch (err) {
            toastError(err);
            throw err;
        }
    };

    let finalBackground;

    const hasValidLightBg = backgroundLight && backgroundLight.trim() !== '';
    const hasValidDarkBg = backgroundDark && backgroundDark.trim() !== '';

    if (mode === "light") {
        if (hasValidLightBg) {
            finalBackground = `url(${backgroundLight})`;
        } else {
            finalBackground = theme.palette.background ? theme.palette.background.default : "#f5f5f5";
        }
    } else {
        if (hasValidDarkBg) {
            finalBackground = `url(${backgroundDark})`;
        } else {
            finalBackground = theme.palette.background ? theme.palette.background.default : "#303030";
        }
    }

    return (
        <React.Fragment>
            <Helmet>
                <title>{appName || i18n.t("signup.title")}</title>
                <link rel="icon" href={appLogoFavicon || "/default-favicon.ico"} />
            </Helmet>

            <div
                className={classes.root}
                style={{
                    backgroundImage: typeof finalBackground === "string" && finalBackground.includes("url(")
                        ? finalBackground
                        : "none"
                }}
            >
                <PublicLanguageSelector />
                <Container
                    component="main"
                    maxWidth={false}
                    className={classes.containerSignup}
                >
                    <CssBaseline />
                    <div className={classes.paper}>
                        <Avatar className={classes.avatar}>
                            {success ? <CheckCircleIcon /> : <LockOutlinedIcon />}
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            {success ? i18n.t("signup.confirmation.title") : i18n.t("signup.title")}
                        </Typography>
                        {success ? (
                            <div style={{ textAlign: "center", marginTop: "20px", width: "100%" }}>
                                <Typography variant="body1" style={{ marginBottom: "12px", fontSize: "16px" }}>
                                    Hemos enviado un enlace de activación al correo:
                                </Typography>
                                <Box
                                    p={1.5}
                                    mb={2}
                                    borderRadius={8}
                                    style={{
                                        backgroundColor: mode === "light" ? "rgba(0, 86, 179, 0.08)" : "rgba(255, 255, 255, 0.08)",
                                        display: "inline-block",
                                        padding: "8px 20px"
                                    }}
                                >
                                    <Typography variant="subtitle1" style={{ fontWeight: "bold", color: theme.palette.primary.main }}>
                                        {registeredEmail}
                                    </Typography>
                                </Box>
                                <Box
                                    p={2}
                                    mb={3}
                                    borderRadius={8}
                                    style={{
                                        backgroundColor: mode === "light" ? "#fff3cd" : "rgba(255, 193, 7, 0.15)",
                                        borderLeft: "4px solid #ffc107",
                                        textAlign: "left"
                                    }}
                                >
                                    <Typography variant="body2" style={{ color: mode === "light" ? "#856404" : "#ffecb5", lineHeight: 1.5 }}>
                                        ⏳ <strong>Importante:</strong> Tienes <strong>7 días</strong> para activar tu cuenta haciendo clic en el enlace que enviamos a tu correo. Si no la activas dentro de este plazo, tu registro será eliminado automáticamente.
                                    </Typography>
                                </Box>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={() => history.push("/login")}
                                >
                                    {i18n.t("signup.confirmation.button")}
                                </Button>
                                <Button
                                    fullWidth
                                    variant="text"
                                    color="default"
                                    style={{ marginTop: "10px", textTransform: "none" }}
                                    onClick={() => setSuccess(false)}
                                >
                                    ¿Escribiste mal tu correo? Volver a registrarte
                                </Button>
                            </div>
                        ) : (
                            <Formik
                                initialValues={user}
                                enableReinitialize={true}
                                validationSchema={UserSchema}
                                onSubmit={async (values, actions) => {
                                    console.log("[TIMEZONE-DEBUG] Signup: values submitted:", values);
                                    try {
                                        await handleSignUp(values);
                                    } catch (e) {
                                        actions.setSubmitting(false);
                                    }
                                }}
                            >
                                {({ values, touched, errors, handleChange, isSubmitting, setFieldValue }) => (
                                    <Form className={classes.form}>
                                        <Grid container spacing={2}>

                                            {/* <Grid item xs={12}>
                                            <Field
                                                as={TextField}
                                                variant="outlined"
                                                fullWidth
                                                id="document"
                                                label="CPF ou CNPJ"
                                                name="document"
                                                error={touched.document && Boolean(errors.document)}
                                                helperText={touched.document && errors.document || "Digite CPF (11 dígitos) ou CNPJ (14 dígitos)"}
                                                autoComplete="document"
                                                inputProps={{
                                                    maxLength: 18,
                                                    style: {textTransform: 'none'}
                                                }}
                                                InputProps={{
                                                    endAdornment: validatingCnpj && (
                                                        <CircularProgress size={20}/>
                                                    ),
                                                }}
                                                autoFocus
                                                onChange={(e) => {
                                                    let value = e.target.value;

                                                    const numbers = value.replace(/\D/g, '');

                                                    if (lastValidatedDocument && lastValidatedDocument !== numbers) {
                                                        setLastValidatedDocument("");
                                                    }

                                                    const formattedValue = formatDocument(value);
                                                    setFieldValue('document', formattedValue);

                                                    if (numbers.length === 11) {
                                                        validateDocument(formattedValue, setFieldValue);
                                                    } else if (numbers.length === 14) {
                                                        validateDocument(formattedValue, setFieldValue);
                                                    }
                                                }}
                                            />
                                        </Grid> */}

                                            {!acceptTerms && (
                                                <Grid item xs={12}>
                                                    <Box
                                                        p={1.5} // Reducido de 2
                                                        mb={1} // Reducido de 2
                                                        style={{
                                                            backgroundColor: mode === "light" ? "rgba(59, 130, 246, 0.05)" : "rgba(59, 130, 246, 0.1)",
                                                            borderRadius: "10px", // Reducido
                                                            border: "1px solid rgba(59, 130, 246, 0.2)",
                                                            textAlign: "justify"
                                                        }}
                                                    >
                                                        <Typography variant="subtitle2" align="center" style={{ fontWeight: "bold", color: "#3b82f6", marginBottom: "4px", fontSize: "0.8rem" }}>
                                                            {i18n.t("signup.legal.title")}
                                                        </Typography>
                                                        <Typography variant="body2" style={{ fontSize: "0.75rem", color: mode === "light" ? "#4b5563" : "#d1d5db", lineHeight: "1.2", textAlign: "justify" }}>
                                                            {i18n.t("signup.legal.description")}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    as={TextField}
                                                    variant="outlined"
                                                    fullWidth
                                                    id="companyName"
                                                    label={i18n.t("signup.form.company")}
                                                    error={touched.companyName && Boolean(errors.companyName)}
                                                    helperText={touched.companyName && errors.companyName}
                                                    name="companyName"
                                                    autoComplete="companyName"
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    as={TextField}
                                                    autoComplete="name"
                                                    name="name"
                                                    error={touched.name && Boolean(errors.name)}
                                                    helperText={touched.name && errors.name}
                                                    variant="outlined"
                                                    fullWidth
                                                    id="name"
                                                    label={i18n.t("signup.form.name")}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    as={TextField}
                                                    variant="outlined"
                                                    fullWidth
                                                    id="email"
                                                    label={i18n.t("signup.form.email")}
                                                    name="email"
                                                    error={touched.email && Boolean(errors.email)}
                                                    helperText={touched.email && errors.email}
                                                    autoComplete="email"
                                                    inputProps={{ style: { textTransform: 'lowercase' } }}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    as={TextField}
                                                    variant="outlined"
                                                    fullWidth
                                                    name="password"
                                                    error={touched.password && Boolean(errors.password)}
                                                    helperText={touched.password && errors.password}
                                                    label={i18n.t("signup.form.password")}
                                                    type="password"
                                                    id="password"
                                                    autoComplete="current-password"
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Field
                                                    as={TextField}
                                                    variant="outlined"
                                                    fullWidth
                                                    id="phone"
                                                    label={i18n.t("signup.form.phone")}
                                                    name="phone"
                                                    autoComplete="phone"
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Typography variant="body2" color="primary" style={{ marginBottom: 4, fontWeight: 'bold', fontSize: '0.75rem' }}>
                                                    ⚠️ Configuración Zona Horaria
                                                </Typography>
                                                <FormControl variant="outlined" fullWidth error={touched.timezone && Boolean(errors.timezone)} required>
                                                    <InputLabel id="timezone-label">Zona Horaria</InputLabel>
                                                    <Select
                                                        label="Zona Horaria"
                                                        labelId="timezone-label"
                                                        id="timezone"
                                                        name="timezone"
                                                        value={values.timezone}
                                                        onChange={handleChange}
                                                        required
                                                    >
                                                        <MenuItem value="" disabled>Seleccione una zona horaria</MenuItem>
                                                        {tzList.map((tz) => (
                                                            <MenuItem key={tz.name} value={tz.name}>
                                                                {tz.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    {touched.timezone && errors.timezone && (
                                                        <Typography variant="caption" color="error">{errors.timezone}</Typography>
                                                    )}
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={acceptTerms}
                                                            onChange={(e) => setAcceptTerms(e.target.checked)}
                                                            color="primary"
                                                            size="small"
                                                        />
                                                    }
                                                    label={
                                                        <Typography variant="body2" style={{ fontSize: "0.85rem", textAlign: "left" }}>
                                                            {i18n.t("signup.form.acceptTerms")}
                                                            <Link
                                                                component="button"
                                                                type="button"
                                                                onClick={() => setShowTerms(true)}
                                                                style={{ verticalAlign: "baseline", fontWeight: "bold", fontSize: "0.75rem" }}
                                                            >
                                                                {i18n.t("signup.links.terms")}
                                                            </Link>{" & "}
                                                            <Link
                                                                component="button"
                                                                type="button"
                                                                onClick={() => setShowPrivacy(true)}
                                                                style={{ verticalAlign: "baseline", fontWeight: "bold", fontSize: "0.75rem" }}
                                                            >
                                                                {i18n.t("signup.links.privacy")}
                                                            </Link>
                                                        </Typography>
                                                    }
                                                />
                                            </Grid>



                                        </Grid>
                                        <Button
                                            type="submit"
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            className={classes.submit}
                                            disabled={validatingCnpj || !acceptTerms || isSubmitting}
                                        >
                                            {i18n.t("signup.buttons.submit")}
                                        </Button>
                                        <Grid container justifyContent="center">
                                            <Grid item>
                                                <Link
                                                    href="#"
                                                    variant="body2"
                                                    component={RouterLink}
                                                    to="/login"
                                                    style={{ textAlign: "center", display: "block", marginTop: "15px" }}
                                                >
                                                    {i18n.t("signup.buttons.login")}
                                                </Link>
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent="center" spacing={3} style={{ marginTop: "10px" }}>
                                            <Grid item>
                                                <Link
                                                    component="button"
                                                    type="button"
                                                    variant="caption"
                                                    onClick={() => setShowTerms(true)}
                                                    style={{ color: mode === "light" ? "#6b7280" : "#9ca3af", textDecoration: "underline" }}
                                                >
                                                    {i18n.t("signup.links.terms")}
                                                </Link>
                                            </Grid>
                                            <Grid item>
                                                <Link
                                                    component="button"
                                                    type="button"
                                                    variant="caption"
                                                    onClick={() => setShowPrivacy(true)}
                                                    style={{ color: mode === "light" ? "#6b7280" : "#9ca3af", textDecoration: "underline" }}
                                                >
                                                    {i18n.t("signup.links.privacy")}
                                                </Link>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                )}
                            </Formik>
                        )}
                    </div>
                    <Box mt={5}>{/* <Copyright /> */}</Box>

                    <LegalRequirementModal
                        open={showTerms}
                        onClose={() => setShowTerms(false)}
                        type="terms"
                    />
                    <LegalRequirementModal
                        open={showPrivacy}
                        onClose={() => setShowPrivacy(false)}
                        type="privacy"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default SignUp;
